import { OptimizelyPropertyCategoryValue } from "../types/optimizely/blocks";

export const getDepartment = (organization?: OptimizelyPropertyCategoryValue) => {
  if (organization?.name === "Wilhelmsen Ship Management") {
    return "Ship Management"
  }
  return organization?.name || organization?.description;
}